import { $toDouble } from "./toDouble";
const $toDecimal = $toDouble;
export {
  $toDecimal
};
